<template>
  <div>
    <loading :active="isLoading" :is-full-page="true"></loading>
    <main>
      <RouterView />
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer/index";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";

export default {
  components: {
    Footer,
    Loading,
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>

<style lang="scss">
@import "./assets/scss/generic/mixins.scss";
@import "./assets/scss/generic/fonts.scss";
@import "./assets/scss/generic/utilities.scss";
</style>
